import { render, staticRenderFns } from "./TopicInfoDialog.vue?vue&type=template&id=7ccc08e2&scoped=true"
import script from "./TopicInfoDialog.vue?vue&type=script&lang=js"
export * from "./TopicInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./TopicInfoDialog.vue?vue&type=style&index=0&id=7ccc08e2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccc08e2",
  null
  
)

export default component.exports